
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { NewMandant } from "../typing/generalType";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";
import { message } from "antd";
// import { myfetchThunk } from "../../../app/myfetch";


// Interface which is expected from api call
interface testdataResponsePayloadInterface{
    save:string
}

export const requestClientCreationFromAPI =(data:NewMandant) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/Mandants",
            {data},
            "POST",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload.save)
                message.success(payload.save +" created");
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                message.error(payload.save+" could not be created");
            },
        ) as any)
    }
}
